import _toConsumableArray from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '@/assets/img/upload/icon-noread@2x.png';
var _hoisted_1 = {
  class: "upload-history-box"
};
var _hoisted_2 = {
  class: "upload-history-dialog-content"
};
var _hoisted_3 = {
  key: 0
};
var _hoisted_4 = {
  class: "detail-title"
};
var _hoisted_5 = {
  class: "title-spe"
};
var _hoisted_6 = {
  class: "warnings warnings-tag"
};
var _hoisted_7 = {
  key: 1
};
var _hoisted_8 = {
  key: 0,
  class: "list-content"
};
var _hoisted_9 = {
  class: "item-name"
};
var _hoisted_10 = {
  class: "name-text"
};
var _hoisted_11 = {
  class: "item-date"
};
var _hoisted_12 = {
  class: "detail-sub-value"
};
var _hoisted_13 = {
  class: "detail-sub-value"
};
var _hoisted_14 = {
  class: "detail-sub-value"
};
var _hoisted_15 = {
  key: 0,
  class: "detail-sub-value"
};
var _hoisted_16 = {
  class: "detail-sub-value"
};
var _hoisted_17 = {
  class: "detail-sub-value"
};
var _hoisted_18 = {
  class: "item-fail"
};
var _hoisted_19 = ["onClick"];
var _hoisted_20 = {
  key: 0,
  class: "unread-info"
};
var _hoisted_21 = {
  key: 1,
  class: "detail-content"
};
var _hoisted_22 = {
  class: "table-container"
};
var _hoisted_23 = {
  class: "detail-footer"
};
var _hoisted_24 = {
  class: "flex-info"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = _resolveComponent("el-input");
  var _component_el_col = _resolveComponent("el-col");
  var _component_el_date_picker = _resolveComponent("el-date-picker");
  var _component_el_row = _resolveComponent("el-row");
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_pagination = _resolveComponent("el-pagination");
  var _component_common_table = _resolveComponent("common-table");
  var _component_el_button = _resolveComponent("el-button");
  var _component_ResultDialog = _resolveComponent("ResultDialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: _normalizeClass({
      'header': true,
      'header-spe': $data.selectFile
    })
  }, [$data.selectFile ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("label", _hoisted_5, [_createElementVNode("span", {
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.goBack && $options.goBack.apply($options, arguments);
    })
  }, "历史上传文件"), _cache[6] || (_cache[6] = _createTextVNode(" / ", -1))]), _createTextVNode(" " + _toDisplayString($data.selectFile.fileOriginName), 1)]), _createElementVNode("div", _hoisted_6, _toDisplayString($options.getFileTypeStr($data.selectFile.type)), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", null, [_createVNode(_component_el_row, {
    gutter: 12
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 12
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: $data.input,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return $data.input = $event;
            }),
            clearable: "",
            placeholder: "搜索",
            "prefix-icon": "Search",
            class: "search-input",
            onKeyup: _withKeys($options.onInputEnter, ["enter", "native"]),
            onClear: $options.onInputClear
          }, null, 8, ["modelValue", "onKeyup", "onClear"])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 12
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_date_picker, {
            modelValue: $data.dateRange,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return $data.dateRange = $event;
            }),
            clearable: "",
            class: "date-picker",
            type: "daterange",
            "range-separator": "-",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            "value-format": "YYYYMMDD",
            onChange: $options.onDateChange
          }, null, 8, ["modelValue", "onChange"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_el_row, {
    gutter: 12,
    class: "second-row"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_select, {
            modelValue: $data.declarationFormType,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return $data.declarationFormType = $event;
            }),
            placeholder: "报关类型",
            class: "seleter",
            clearable: "",
            onChange: $options.declarationFormTypeChange
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.declarationTypes, function (item) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["modelValue", "onChange"])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_select, {
            modelValue: $data.fileType,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return $data.fileType = $event;
            }),
            placeholder: "模板格式",
            class: "seleter",
            clearable: "",
            onChange: $options.fileTypeChange
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fileTypes, function (item) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["modelValue", "onChange"])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_select, {
            modelValue: $data.filterCheckedValue,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
              return $data.filterCheckedValue = $event;
            }),
            placeholder: "状态",
            class: "seleter",
            clearable: "",
            onChange: $options.filterChange
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.filterOptions, function (item) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["modelValue", "onChange"])];
        }),
        _: 1
      })];
    }),
    _: 1
  })])]))], 2), !$data.selectFile ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.files, function (item) {
    return _openBlock(), _createElementBlock("div", {
      key: item.id,
      class: "list-item"
    }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(item.fileOriginName), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(item.createTime), 1)]), _cache[13] || (_cache[13] = _createElementVNode("div", null, [_createElementVNode("span", {
      class: "seat-line"
    })], -1)), _createVNode(_component_el_row, {
      class: "detail-row"
    }, {
      default: _withCtx(function () {
        return [_createVNode(_component_el_col, {
          span: 5
        }, {
          default: _withCtx(function () {
            return _toConsumableArray(_cache[7] || (_cache[7] = [_createElementVNode("span", {
              class: "detail-sub-title"
            }, "报关类型：", -1)]));
          }),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 19
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_12, _toDisplayString($options.getFileTypeStr(item.type)), 1)];
          }),
          _: 2
        }, 1024)];
      }),
      _: 2
    }, 1024), _createVNode(_component_el_row, {
      class: "detail-row"
    }, {
      default: _withCtx(function () {
        return [_createVNode(_component_el_col, {
          span: 5
        }, {
          default: _withCtx(function () {
            return _toConsumableArray(_cache[8] || (_cache[8] = [_createElementVNode("span", {
              class: "detail-sub-title"
            }, "数据形式：", -1)]));
          }),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 9
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_13, _toDisplayString(item.isRowData ? '数据库表格' : '报关单草单'), 1)];
          }),
          _: 2
        }, 1024), _createVNode(_component_el_col, {
          span: 5
        }, {
          default: _withCtx(function () {
            return _toConsumableArray(_cache[9] || (_cache[9] = [_createElementVNode("span", {
              class: "detail-sub-title"
            }, "模板格式：", -1)]));
          }),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 5
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_14, _toDisplayString(item.isFixed ? '固定模板' : '自定义模板'), 1)];
          }),
          _: 2
        }, 1024)];
      }),
      _: 2
    }, 1024), _createVNode(_component_el_row, {
      class: "detail-row"
    }, {
      default: _withCtx(function () {
        return [_createVNode(_component_el_col, {
          span: 5
        }, {
          default: _withCtx(function () {
            return _toConsumableArray(_cache[10] || (_cache[10] = [_createElementVNode("span", {
              class: "detail-sub-title"
            }, "上传结果：", -1)]));
          }),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 19
        }, {
          default: _withCtx(function () {
            return [item.isFixed || item.isRowData ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString("\u6210\u529F\u65B0\u589E".concat(item.ticketSuccess, "\u7968\u62A5\u5173\u5355\uFF0C")), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_16, _toDisplayString("\u6210\u529F\u65B0\u589E".concat(item.success).concat($options.getUnitString(item), "\uFF0C")), 1), _createElementVNode("span", _hoisted_17, _toDisplayString("\u91CD\u590D\u4E0A\u4F20".concat(item.repeat).concat($options.getUnitString(item), "\uFF0C")), 1), _createElementVNode("span", _hoisted_18, _toDisplayString("\u5F02\u5E38".concat(item.abnormal).concat($options.getUnitString(item))), 1)];
          }),
          _: 2
        }, 1024)];
      }),
      _: 2
    }, 1024), _createElementVNode("div", {
      class: _normalizeClass(["goto-detail-text-enable", {
        'goto-detail-text-disable': item.abnormal === 0 && item.repeat === 0 || !item.logDetail
      }]),
      onClick: function onClick($event) {
        return $options.showDetail(item);
      }
    }, _toConsumableArray(_cache[11] || (_cache[11] = [_createElementVNode("a", null, [_createTextVNode(" 查看详情 "), _createElementVNode("i", {
      class: "el-icon-arrow-right"
    })], -1)])), 10, _hoisted_19), !item.confirm ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toConsumableArray(_cache[12] || (_cache[12] = [_createElementVNode("img", {
      src: _imports_0,
      class: "no-read-image"
    }, null, -1)])))) : _createCommentVNode("", true)]);
  }), 128)), _createVNode(_component_el_pagination, {
    class: "history-pagination",
    layout: "prev, pager, next",
    "page-size": 10,
    "pager-count": 5,
    total: $data.total,
    "current-page": $data.currentPage,
    onCurrentChange: $options.currentChange
  }, null, 8, ["total", "current-page", "onCurrentChange"])])) : (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_common_table, {
    class: "detail-table",
    "table-data": $data.tableData,
    columns: $data.columns,
    options: $data.options
  }, null, 8, ["table-data", "columns", "options"])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
    type: "text",
    icon: "el-icon-arrow-left",
    onClick: $options.goBack
  }, {
    default: _withCtx(function () {
      return _toConsumableArray(_cache[14] || (_cache[14] = [_createTextVNode("返回", -1)]));
    }),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    round: "",
    type: "primary",
    onClick: $options.reLoad
  }, {
    default: _withCtx(function () {
      return _toConsumableArray(_cache[15] || (_cache[15] = [_createTextVNode("导出", -1)]));
    }),
    _: 1
  }, 8, ["onClick"])]), _createVNode(_component_el_pagination, {
    layout: "prev, pager, next",
    "page-size": 10,
    "pager-count": 5,
    total: $data.detailTotal,
    "current-page": $data.detailCurrentPage,
    onCurrentChange: $options.detailCurrentChange
  }, null, 8, ["total", "current-page", "onCurrentChange"])])])])), _createVNode(_component_ResultDialog, {
    ref: "resultDialogRef"
  }, null, 512)])]);
}